(function() {
	'use strict';

	angular.module('app.leanProjects')
		.directive('metricsSection', metricsSection);

	metricsSection.$inject = ['$rootScope'];

	function metricsSection($rootScope) {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/lean-projects/projects/metrics-section.html',
			scope: {
				projectNdx: '@projectNdx',
				managerNdx: '@managerNdx',
				details: '=',
				userRoles: '@userRoles',
				leanDirFactoryNdx: '@leanDirFactoryNdx'
			},
			controller: metricsSectionController,
			controllerAs: 'metricsSectionController',
			bindToController: true
		};
	}

	metricsSectionController.$inject = ['$scope', '$rootScope', '$uibModal', '$compile', '$filter',
		'editProjectService', 'leanProjectAuthService', 'newProjectService', 'viewProjectsService'];
	function metricsSectionController($scope, $rootScope, $uibModal, $compile, $filter,
			editProjectService, leanProjectAuthService, newProjectService, viewProjectsService) {
		var vm = this;
		vm.metrics = [];
		vm.metricList = [];
		vm.deleteMetric = deleteMetric;
		vm.showEditList = showEditList;
		vm.saveEditList = saveEditList;
		vm.cancelEdit = cancelEdit;
		vm.addMetric = addMetric;
		vm.actionIsAllowed = actionIsAllowed;
		vm.valueStreamList = [];

		function actionIsAllowed(action) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details);
		}

		function showEditList(type, rowNdx) {
			editProjectService.getValueStreams(vm.leanDirFactoryNdx, vm.projectNdx, vm.metrics[rowNdx].metricNdx, vm.metrics[rowNdx].valueStreamNdx)
				.then(function(valueStreams) {
					if (!valueStreams) {
						valueStreams = [];
					}
					if (vm.metrics[rowNdx].valueStreamNdx === 0 || !vm.plantWideMap[vm.metrics[rowNdx].metricNdx]) {
						valueStreams.unshift({'valueStreamName': 'Plant Wide', 'valueStreamNdx':0});
					}
					vm.valueStreamList = valueStreams;
				});
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + type + rowNdx);
			var pos = cell.offset();
			var editTemplate = getListTemplate(pos, type, rowNdx);
			vm.currentListOption = vm.metrics[rowNdx].valueStreamNdx;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					vm.saveEditList(type, rowNdx);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function getListTemplate(position, type, rowNdx) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 240 > windowHeight) {
				position.top = position.top - (position.top + 240 - windowHeight - 8);
			}
			var label = 'Value Stream';
			var display = 'valueStreamName';
			var value = 'valueStreamNdx';
			var listName = 'valueStreamList';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader"><span translate>Choose ' + label + '</span></div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="metricsSectionController.currentListOption">' +
				'<ui-select-match placeholder="{{\'Select ' + label.toLowerCase() + '...\'' + ' | translate}}">' +
				'{{$select.selected.' + display + ' | translate}}' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item.' + value + ' as item in metricsSectionController.' + listName + ' | filter: $select.search">' +
				'<div>{{item.' + display + ' | translate}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="metricsSectionController.cancelEdit()">{{\'Cancel\' | translate }}</button>' +
				'<button class="button flat colored" ng-click="metricsSectionController.saveEditList(\'' + type + '\', ' + rowNdx + ')">{{\'Save\' | translate }}</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function saveEditList(type, rowNdx) {
			var saveObj = {};
			saveObj.newValueStreamNdx = vm.currentListOption;
			saveObj.oldValueStreamNdx = vm.metrics[rowNdx].valueStreamNdx;
			saveObj.metricNdx = vm.metrics[rowNdx].metricNdx;
			if (saveObj.newValueStreamNdx != saveObj.oldValueStreamNdx) {
				if (saveObj.valueStreamNdx != vm.metrics[rowNdx].valueStreamNdx) {
					editProjectService.editMetric(vm.projectNdx, vm.leanDirFactoryNdx, saveObj, (new Date(vm.details.lastModified)).toUTCString())
						.then(function(message) {
							var isSuccessful = message == 'Metric value stream saved successfully';
							$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
							$rootScope.$emit('activityUpdated');
							$scope.$emit('updateLastModified');
							loadMetrics();
						});
				}
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		}

		function deleteMetric(rowNdx) {
			var metricNdx = vm.metrics[rowNdx].metricNdx;
			var valueStreamNdx = vm.metrics[rowNdx].valueStreamNdx;
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'delete this metric';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				instance.close();
				confirmScope.$destroy();
				editProjectService.deleteMetric(vm.projectNdx, vm.leanDirFactoryNdx, metricNdx, valueStreamNdx, 
					(new Date(vm.details.lastModified)).toUTCString()).then(function(message) {
					var result = message === 'Metric deleted successfully';
					$rootScope.$emit('toast', {'message': message, 'success': result});
					$rootScope.$emit('activityUpdated');
					$scope.$emit('updateLastModified');
					if (result) loadMetrics();
				});
			};
		}

		function addMetric() {
			var addMetricScope = $scope.$new();
			editProjectService.getAllMetrics(vm.leanDirFactoryNdx).then(function(metrics) {
				addMetricScope.metrics = metrics;
			});
			addMetricScope.selected = {};
			addMetricScope.save = save;
			addMetricScope.selectMetric = selectMetric;
			addMetricScope.closeDialog = closeDialog;

			var opts = {
				scope: addMetricScope,
				templateUrl: '/application/f/lean-projects/add-metric.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);

			function save() {
				var metricObj = {};
				metricObj.metricNdx = addMetricScope.selected.metricNdx;
				metricObj.newValueStreamNdx = addMetricScope.selected.valueStreamNdx;
				editProjectService.addMetric(vm.projectNdx, vm.leanDirFactoryNdx, metricObj, (new Date(vm.details.lastModified)).toUTCString())
					.then(function(message) {
						var isSuccessful = message == 'Metric added successfully';
						$rootScope.$emit('activityUpdated');
						$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
						$scope.$emit('updateLastModified');
						if (isSuccessful) {
							loadMetrics();
						}
					});
				closeDialog();
			}

			function selectMetric() {
				editProjectService.getValueStreams(vm.leanDirFactoryNdx, vm.projectNdx, addMetricScope.selected.metricNdx, -1)
					.then(function(valueStreams) {
						addMetricScope.hasError = false;
						if (!valueStreams) valueStreams = [];
						if (!vm.plantWideMap[addMetricScope.selected.metricNdx]) {
							 valueStreams.unshift({'valueStreamName': 'Plant Wide', 'valueStreamNdx':0});
						} else {
							if (valueStreams.length == 0) {
								addMetricScope.errorMessage = 'You already have selected this plant wide metric. Please select a different metric.';
								addMetricScope.hasError = true;
								return;
							}
						}
						addMetricScope.valueStreams = valueStreams;
						// Check if they had already selected a value stream, and if so is it available with the new metric
						if (addMetricScope.selected.valueStreamNdx || addMetricScope.selected.valueStreamNdx == 0) {
							var found = false;
							for (var i = 0; i < valueStreams.length; i++) {
								if (valueStreams[i].valueStreamNdx == addMetricScope.selected.valueStreamNdx) {
									found = true;
									break;
								}
							}
							if (!found) addMetricScope.selected.valueStreamNdx = undefined;
						} else {
							//Default to first option
							addMetricScope.selected.valueStreamNdx = addMetricScope.valueStreams[0].valueStreamNdx;
						}
					});
			}

			function closeDialog() {
				instance.close();
				addMetricScope.$destroy();
			};
		}

		function loadMetrics() {
			editProjectService.getMetrics(vm.projectNdx, vm.leanDirFactoryNdx)
				.then(function(metrics) {
					vm.plantWideMap = {};
					vm.metricList = metrics;
					vm.metrics = [].concat(vm.metricList);
					for(var i = 0; i < metrics.length; i++) {
						var m = metrics[i];
						if (m.valueStreamNdx == 0) {
							vm.plantWideMap[m.metricNdx] = true;
						}
						m.metricName = strip(m.metricName);
					}
				});
		}

		function init() {
			loadMetrics();
		}

		this.$onInit = function () {
			init();
		};
	}

})();
